import { fetchAllPropertyValues } from '../../values/api';
import { InMemoryCache } from '../InMemoryCache';
const toCacheKey = ({
  objectTypeId,
  objectId
}) => `${objectTypeId}/${objectId}`;
const fetcher = (key, promiseClient) => {
  const {
    objectTypeId,
    objectId
  } = key;
  return fetchAllPropertyValues(objectId, objectTypeId, promiseClient).then(res => {
    const cachedValues = Object.entries(res.properties).reduce((acc, [name, property]) => {
      const {
        value,
        sourceId,
        sensitivityLevel
      } = property;
      acc[name] = {
        value,
        sourceId,
        sensitivityLevel
      };
      return acc;
    }, {});
    return cachedValues;
  });
};
export const makePropertyValuesCache = () => new InMemoryCache('PropertyValuesCache', toCacheKey, ({
  httpClient
}) => key => fetcher(key, httpClient));